import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import AstrologerRegister from "./pages/AstrologerRegister";
import AstrologerPersonalInfo from "./pages/AstrologerPersonalInfo";
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/astrologer-register" replace />} />
        <Route path="/astrologer-register" element={<AstrologerRegister />} />
        <Route path="/astrologer-register-personal-info" element={<AstrologerPersonalInfo />} />
        <Route path="/astrologer-register-complete-profile" element={<Navigate to="/astrologer-register-personal-info" replace />} />
        <Route path="*" element={<Navigate to="/astrologer-register" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
